import { FusePageSimple } from '@fuse';
import _ from '@lodash';
import { Collapse, Icon, TextField, Typography, withStyles } from '@material-ui/core';
import XAPPButton from 'app/Core/Components/Button/XAPPButton';
import CatchErro from 'app/Core/Components/CatchErro/CatchErro';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import * as AppActions from 'app/store/actions';
import withReducer from 'app/store/withReducer';
import clsx from 'clsx';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import * as Actions from './Store/Actions/EmpresaPessoaJornadaActions';
import reducer from './Store/Reducers/EmpresaPessoaJornadaReducer';

const styles = theme => ({
    root: {
        color: theme.palette.text.primary,
    },
    bgDiv: {
        //backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.main,
        border: "1px solid" + theme.palette.primary.main,
        borderRadius: "5px",
        marginBottom: "5px"
    }
});

const NewState = {
    "openCollapse": [],
    "tipo": 126,
    "idparent": null,
    "idpessoaformulario": null,
    "idpessoa": null,
    "formulario": {
        "segunda": { "entrada1": null, "saida1": null, "entrada2": null, "saida2": null },
        "terca": { "entrada1": null, "saida1": null, "entrada2": null, "saida2": null },
        "quarta": { "entrada1": null, "saida1": null, "entrada2": null, "saida2": null },
        "quinta": { "entrada1": null, "saida1": null, "entrada2": null, "saida2": null },
        "sexta": { "entrada1": null, "saida1": null, "entrada2": null, "saida2": null },
        "sabado": { "entrada1": null, "saida1": null, "entrada2": null, "saida2": null },
        "domingo": { "entrada1": null, "saida1": null, "entrada2": null, "saida2": null }
    }

}

class EmpresaPessoaJornadaApp extends XAPPComponent {

    state = {
        ...NewState,
        idparent: this.props.idparent,
        idpessoa: this.props.xappRouteParams.empresa
    }

    componentDidMount() {
        const { xappRouteParams, idparent, get } = this.props;
        get("SELECIONAR", xappRouteParams, idparent);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.EmpresaPessoaJornada.info) {
            this.props.showMessage({
                message: this.props.EmpresaPessoaJornada.info,
                variant: 'success'
            });
            this.props.EmpresaPessoaJornada.info = null;
        }
        if (this.props.EmpresaPessoaJornada.warning) {
            this.props.showMessage({
                message: this.props.EmpresaPessoaJornada.warning,
                variant: 'warning'
            });
            this.props.EmpresaPessoaJornada.warning = null;
        }
        if (this.props.EmpresaPessoaJornada.error) {
            this.props.showMessage({
                message: this.props.EmpresaPessoaJornada.error,
                variant: 'error'
            });
            this.props.EmpresaPessoaJornada.error = null;
        }

        if (!_.isEqual(prevProps.EmpresaPessoaJornada.data, this.props.EmpresaPessoaJornada.data)) {
            if (!_.isNull(this.props.EmpresaPessoaJornada.data)) {
                this.setState(this.props.EmpresaPessoaJornada.data[0]);
            }
            else {
                this.setState(NewState);
            }
        }
    }

    componentWillUnmount() {
        this.props.clearReducer();
    }

    openCollapse = (_AValue) => {
        this.setState((state) => {
            if (state.openCollapse.includes(_AValue)) {
                state.openCollapse.splice(state.openCollapse.indexOf(_AValue), 1);
            }
            else {
                state.openCollapse.push(_AValue);
            }
            return state;
        });
    }

    handleChange = (event) => {
        this.setState(_.set({ ...this.state }, event.target.name, event.target.value));
    };

    canBeSubmitted() {
        const { tipo, idpessoaformulario } = this.state;
        return (
            tipo !== null && idpessoaformulario !== null
        );
    }

    changeAll = () => {
        this.setState(state => {
            state.openCollapse = [1, 2, 3, 4, 5, 6, 7];
            state.formulario.terca = Object.assign({}, state.formulario.segunda);
            state.formulario.quarta = Object.assign({}, state.formulario.segunda);
            state.formulario.quinta = Object.assign({}, state.formulario.segunda);
            state.formulario.sexta = Object.assign({}, state.formulario.segunda);
            state.formulario.sabado = Object.assign({}, state.formulario.segunda);
            state.formulario.domingo = Object.assign({}, state.formulario.segunda);
            return state;
        });
    }

    render() {
        const { classes, save, xappRouteParams, idparent, Pessoa } = this.props;
        const form = this.state;
        return (
            <React.Fragment>
                <CatchErro
                    url={this.props.match.url}
                >
                    <FusePageSimple
                        classes={{
                            contentCardWrapper: "p-16 sm:p-24 pb-80",
                            leftSidebar: "w-256 border-0",
                            header: "hidden"
                        }}
                        content={
                            <React.Fragment>
                                <div className="w-full flex justify-end">
                                    <XAPPButton
                                        tooltip={{ "title": "Aplicar mesmo horário a todos os dias", "placement": "top" }}
                                        type="button"
                                        className=""
                                        variant="text"
                                        color="primary"
                                        onClick={() => this.changeAll()}
                                        label={"Aplicar a todos"}
                                    />
                                </div>
                                <React.Fragment id="segunda-feira">
                                    <div className={clsx(classes.bgDiv, "flex p-8 items-center cursor-pointer")} onClick={() => this.openCollapse(1)}>
                                        <Typography className="inline font-medium" color="primary" paragraph={false}>
                                            {"Segunda-feira"}
                                        </Typography>
                                        <div className="flex-1" />
                                        <Icon color="primary" className="text-20">{form.openCollapse.includes(1) ? "expand_less" : "expand_more"}</Icon>
                                    </div>
                                    <Collapse in={form.openCollapse.includes(1)} timeout="auto" >
                                        <div className="flex sm:flex-no-wrap flex-wrap">
                                            <TextField
                                                className="mr-8 my-8 w-1/4"
                                                label="Entrada"
                                                name="formulario.segunda.entrada1"
                                                value={form.formulario.segunda.entrada1}
                                                onChange={this.handleChange}
                                                variant="outlined"
                                                required
                                                fullWidth
                                                type={"Time"}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                            <TextField
                                                className="mr-8 my-8 w-1/4"
                                                label="Saída"
                                                name="formulario.segunda.saida1"
                                                value={form.formulario.segunda.saida1}
                                                onChange={this.handleChange}
                                                variant="outlined"
                                                required
                                                fullWidth
                                                type={"Time"}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                            <TextField
                                                className="mr-8 my-8 w-1/4"
                                                label="Entrada"
                                                name="formulario.segunda.entrada2"
                                                value={form.formulario.segunda.entrada2}
                                                onChange={this.handleChange}
                                                variant="outlined"
                                                required
                                                fullWidth
                                                type={"Time"}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                            <TextField
                                                className="mr-8 my-8 w-1/4"
                                                label="Saída"
                                                name="formulario.segunda.saida2"
                                                value={form.formulario.segunda.saida2}
                                                onChange={this.handleChange}
                                                variant="outlined"
                                                required
                                                fullWidth
                                                type={"Time"}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </div>
                                    </Collapse>
                                </React.Fragment>
                                <React.Fragment id="terca-feira">
                                    <div className={clsx(classes.bgDiv, "flex p-8 items-center cursor-pointer")} onClick={() => this.openCollapse(2)}>
                                        <Typography className="inline font-medium" color="primary" paragraph={false}>
                                            {"Terça-feira"}
                                        </Typography>
                                        <div className="flex-1" />
                                        <Icon color="primary" className="text-20 ">{form.openCollapse.includes(2) ? "expand_less" : "expand_more"}</Icon>
                                    </div>
                                    <Collapse in={form.openCollapse.includes(2)} timeout="auto" >
                                        <div className="flex sm:flex-no-wrap flex-wrap">
                                            <TextField
                                                className="mr-8 my-8 w-1/4"
                                                label="Entrada"
                                                name="formulario.terca.entrada1"
                                                value={form.formulario.terca.entrada1}
                                                onChange={this.handleChange}
                                                variant="outlined"
                                                required
                                                fullWidth
                                                type={"Time"}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                            <TextField
                                                className="mr-8 my-8 w-1/4"
                                                label="Saída"
                                                name="formulario.terca.saida1"
                                                value={form.formulario.terca.saida1}
                                                onChange={this.handleChange}
                                                variant="outlined"
                                                required
                                                fullWidth
                                                type={"Time"}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                            <TextField
                                                className="mr-8 my-8 w-1/4"
                                                label="Entrada"
                                                name="formulario.terca.entrada2"
                                                value={form.formulario.terca.entrada2}
                                                onChange={this.handleChange}
                                                variant="outlined"
                                                required
                                                fullWidth
                                                type={"Time"}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                            <TextField
                                                className="mr-8 my-8 w-1/4"
                                                label="Saída"
                                                name="formulario.terca.saida2"
                                                value={form.formulario.terca.saida2}
                                                onChange={this.handleChange}
                                                variant="outlined"
                                                required
                                                fullWidth
                                                type={"Time"}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </div>
                                    </Collapse>
                                </React.Fragment>
                                <React.Fragment id="quarta-feira">
                                    <div className={clsx(classes.bgDiv, "flex p-8 items-center cursor-pointer")} onClick={() => this.openCollapse(3)}>
                                        <Typography className="inline font-medium" color="primary" paragraph={false}>
                                            {"Quarta-feira"}
                                        </Typography>
                                        <div className="flex-1" />
                                        <Icon color="primary" className="text-20 ">{form.openCollapse.includes(3) ? "expand_less" : "expand_more"}</Icon>
                                    </div>
                                    <Collapse in={form.openCollapse.includes(3)} timeout="auto" >
                                        <div className="flex sm:flex-no-wrap flex-wrap">
                                            <TextField
                                                className="mr-8 my-8 w-1/4"
                                                label="Entrada"
                                                name="formulario.quarta.entrada1"
                                                value={form.formulario.quarta.entrada1}
                                                onChange={this.handleChange}
                                                variant="outlined"
                                                required
                                                fullWidth
                                                type={"Time"}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                            <TextField
                                                className="mr-8 my-8 w-1/4"
                                                label="Saída"
                                                name="formulario.quarta.saida1"
                                                value={form.formulario.quarta.saida1}
                                                onChange={this.handleChange}
                                                variant="outlined"
                                                required
                                                fullWidth
                                                type={"Time"}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                            <TextField
                                                className="mr-8 my-8 w-1/4"
                                                label="Entrada"
                                                name="formulario.quarta.entrada2"
                                                value={form.formulario.quarta.entrada2}
                                                onChange={this.handleChange}
                                                variant="outlined"
                                                required
                                                fullWidth
                                                type={"Time"}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                            <TextField
                                                className="mr-8 my-8 w-1/4"
                                                label="Saída"
                                                name="formulario.quarta.saida2"
                                                value={form.formulario.quarta.saida2}
                                                onChange={this.handleChange}
                                                variant="outlined"
                                                required
                                                fullWidth
                                                type={"Time"}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </div>
                                    </Collapse>
                                </React.Fragment>
                                <React.Fragment id="quinta-feira">
                                    <div className={clsx(classes.bgDiv, "flex p-8 items-center cursor-pointer")} onClick={() => this.openCollapse(4)}>
                                        <Typography className="inline font-medium" color="primary" paragraph={false}>
                                            {"Quinta-feira"}
                                        </Typography>
                                        <div className="flex-1" />
                                        <Icon color="primary" className="text-20 ">{form.openCollapse.includes(4) ? "expand_less" : "expand_more"}</Icon>
                                    </div>
                                    <Collapse in={form.openCollapse.includes(4)} timeout="auto" >
                                        <div className="flex sm:flex-no-wrap flex-wrap">
                                            <TextField
                                                className="mr-8 my-8 w-1/4"
                                                label="Entrada"
                                                name="formulario.quinta.entrada1"
                                                value={form.formulario.quinta.entrada1}
                                                onChange={this.handleChange}
                                                variant="outlined"
                                                required
                                                fullWidth
                                                type={"Time"}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                            <TextField
                                                className="mr-8 my-8 w-1/4"
                                                label="Saída"
                                                name="formulario.quinta.saida1"
                                                value={form.formulario.quinta.saida1}
                                                onChange={this.handleChange}
                                                variant="outlined"
                                                required
                                                fullWidth
                                                type={"Time"}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                            <TextField
                                                className="mr-8 my-8 w-1/4"
                                                label="Entrada"
                                                name="formulario.quinta.entrada2"
                                                value={form.formulario.quinta.entrada2}
                                                onChange={this.handleChange}
                                                variant="outlined"
                                                required
                                                fullWidth
                                                type={"Time"}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                            <TextField
                                                className="mr-8 my-8 w-1/4"
                                                label="Saída"
                                                name="formulario.quinta.saida2"
                                                value={form.formulario.quinta.saida2}
                                                onChange={this.handleChange}
                                                variant="outlined"
                                                required
                                                fullWidth
                                                type={"Time"}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </div>
                                    </Collapse>
                                </React.Fragment>
                                <React.Fragment id="sexta-feira">
                                    <div className={clsx(classes.bgDiv, "flex p-8 items-center cursor-pointer")} onClick={() => this.openCollapse(5)}>
                                        <Typography className="inline font-medium" color="primary" paragraph={false}>
                                            {"Sexta-feira"}
                                        </Typography>
                                        <div className="flex-1" />
                                        <Icon color="primary" className="text-20 ">{form.openCollapse.includes(5) ? "expand_less" : "expand_more"}</Icon>
                                    </div>
                                    <Collapse in={form.openCollapse.includes(5)} timeout="auto" >
                                        <div className="flex sm:flex-no-wrap flex-wrap">
                                            <TextField
                                                className="mr-8 my-8 w-1/4"
                                                label="Entrada"
                                                name="formulario.sexta.entrada1"
                                                value={form.formulario.sexta.entrada1}
                                                onChange={this.handleChange}
                                                variant="outlined"
                                                required
                                                fullWidth
                                                type={"Time"}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                            <TextField
                                                className="mr-8 my-8 w-1/4"
                                                label="Saída"
                                                name="formulario.sexta.saida1"
                                                value={form.formulario.sexta.saida1}
                                                onChange={this.handleChange}
                                                variant="outlined"
                                                required
                                                fullWidth
                                                type={"Time"}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                            <TextField
                                                className="mr-8 my-8 w-1/4"
                                                label="Entrada"
                                                name="formulario.sexta.entrada2"
                                                value={form.formulario.sexta.entrada2}
                                                onChange={this.handleChange}
                                                variant="outlined"
                                                required
                                                fullWidth
                                                type={"Time"}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                            <TextField
                                                className="mr-8 my-8 w-1/4"
                                                label="Saída"
                                                name="formulario.sexta.saida2"
                                                value={form.formulario.sexta.saida2}
                                                onChange={this.handleChange}
                                                variant="outlined"
                                                required
                                                fullWidth
                                                type={"Time"}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </div>
                                    </Collapse>
                                </React.Fragment>
                                <React.Fragment id="sabado">
                                    <div className={clsx(classes.bgDiv, "flex p-8 items-center cursor-pointer")} onClick={() => this.openCollapse(6)}>
                                        <Typography className="inline font-medium" color="primary" paragraph={false}>
                                            {"Sábado"}
                                        </Typography>
                                        <div className="flex-1" />
                                        <Icon color="primary" className="text-20 ">{form.openCollapse.includes(6) ? "expand_less" : "expand_more"}</Icon>
                                    </div>
                                    <Collapse in={form.openCollapse.includes(6)} timeout="auto" >
                                        <div className="flex sm:flex-no-wrap flex-wrap">
                                            <TextField
                                                className="mr-8 my-8 w-1/4"
                                                label="Entrada"
                                                name="formulario.sabado.entrada1"
                                                value={form.formulario.sabado.entrada1}
                                                onChange={this.handleChange}
                                                variant="outlined"
                                                required
                                                fullWidth
                                                type={"Time"}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                            <TextField
                                                className="mr-8 my-8 w-1/4"
                                                label="Saída"
                                                name="formulario.sabado.saida1"
                                                value={form.formulario.sabado.saida1}
                                                onChange={this.handleChange}
                                                variant="outlined"
                                                required
                                                fullWidth
                                                type={"Time"}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                            <TextField
                                                className="mr-8 my-8 w-1/4"
                                                label="Entrada"
                                                name="formulario.sabado.entrada2"
                                                value={form.formulario.sabado.entrada2}
                                                onChange={this.handleChange}
                                                variant="outlined"
                                                required
                                                fullWidth
                                                type={"Time"}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                            <TextField
                                                className="mr-8 my-8 w-1/4"
                                                label="Saída"
                                                name="formulario.sabado.saida2"
                                                value={form.formulario.sabado.saida2}
                                                onChange={this.handleChange}
                                                variant="outlined"
                                                required
                                                fullWidth
                                                type={"Time"}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </div>
                                    </Collapse>
                                </React.Fragment>
                                <React.Fragment id="domingo">
                                    <div className={clsx(classes.bgDiv, "flex p-8 items-center cursor-pointer")} onClick={() => this.openCollapse(7)}>
                                        <Typography className="inline font-medium" color="primary" paragraph={false}>
                                            {"Domingo"}
                                        </Typography>
                                        <div className="flex-1" />
                                        <Icon color="primary" className="text-20 ">{form.openCollapse.includes(7) ? "expand_less" : "expand_more"}</Icon>
                                    </div>
                                    <Collapse in={form.openCollapse.includes(7)} timeout="auto" >
                                        <div className="flex sm:flex-no-wrap flex-wrap">
                                            <TextField
                                                className="mr-8 my-8 w-1/4"
                                                label="Entrada"
                                                name="formulario.domingo.entrada1"
                                                value={form.formulario.domingo.entrada1}
                                                onChange={this.handleChange}
                                                variant="outlined"
                                                required
                                                fullWidth
                                                type={"Time"}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                            <TextField
                                                className="mr-8 my-8 w-1/4"
                                                label="Saída"
                                                name="formulario.domingo.saida1"
                                                value={form.formulario.domingo.saida1}
                                                onChange={this.handleChange}
                                                variant="outlined"
                                                required
                                                fullWidth
                                                type={"Time"}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                            <TextField
                                                className="mr-8 my-8 w-1/4"
                                                label="Entrada"
                                                name="formulario.domingo.entrada2"
                                                value={form.formulario.domingo.entrada2}
                                                onChange={this.handleChange}
                                                variant="outlined"
                                                required
                                                fullWidth
                                                type={"Time"}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                            <TextField
                                                className="mr-8 my-8 w-1/4"
                                                label="Saída"
                                                name="formulario.domingo.saida2"
                                                value={form.formulario.domingo.saida2}
                                                onChange={this.handleChange}
                                                variant="outlined"
                                                required
                                                fullWidth
                                                type={"Time"}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </div>
                                    </Collapse>
                                </React.Fragment>
                                <div className="w-full flex justify-end mt-8">
                                    <XAPPButton
                                        type="button"
                                        className=""
                                        variant="contained"
                                        color="primary"
                                        onClick={() => save(form, xappRouteParams, idparent)}
                                        iconProps={"mr-8 text-white"}
                                        label={"Salvar"}
                                        icon={"save"}
                                    />
                                </div>
                            </React.Fragment>
                        }
                        sidebarInner
                        onRef={instance => {
                            this.pageLayout = instance;
                        }}
                        innerScroll
                    />
                </CatchErro>
            </React.Fragment>
        )
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        get: Actions.get,
        save: Actions.save,
        clearReducer: Actions.clearReducer,
        showMessage: AppActions.showMessage,
    }, dispatch);
}

function mapStateToProps({ Pessoa, EmpresaPessoaJornada }) {
    return {
        EmpresaPessoaJornada: EmpresaPessoaJornada,
        Pessoa: Pessoa.EmpresaPessoaReducer.formDialog.data,
    }
}

export default withReducer('EmpresaPessoaJornada', reducer)(withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(EmpresaPessoaJornadaApp))));
